import { render, staticRenderFns } from "./NoticeBoardForm.vue?vue&type=template&id=1dfbe9eb&scoped=true"
import script from "./NoticeBoardForm.vue?vue&type=script&lang=js"
export * from "./NoticeBoardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbe9eb",
  null
  
)

export default component.exports